export default "__VITE_ASSET__DUOtxYwE__"